import { c as _c } from "react/compiler-runtime";
import ApplyForm from "@/features/inquiry-landing/ui/molecules/ApplyForm";
import CheckMark from "@/widgets/inquiry-landing/ui/atoms/CheckMark";
const CHECK_POINTS = ["입점 신청 후 영업일 기준 1일 내 연락", "초기 컨설팅 및 노출 진단 무료", "약정 없이 언제든 시작·해지 가능"] as const;
const ApplyCta = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img src="/inquiry-landing/apply/rocket.svg" alt="" aria-hidden="true" width={57} height={57} className="h-12 w-12 object-contain lg:h-[57px] lg:w-[57px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col items-center gap-5 lg:items-start">{t0}<h2 className="break-keep font-[family-name:var(--font-nanum-square-neo)] text-[32px] font-extrabold leading-[1.35] tracking-[-0.8px] sm:text-[34px] lg:text-[44px] lg:tracking-[-1.26px]"><span className="block text-[#19191a]">우리 병원 리뷰,</span><span className="block text-[#2800ca]">AI에 노출할 준비되셨나요?</span></h2></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br aria-hidden={true} className="sm:hidden" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-center gap-[18px] lg:items-start">{t1}<p className="break-keep text-[17px] font-medium leading-[1.55] text-black sm:text-[16.5px] lg:text-[18px] lg:leading-[27.23px]">아래 정보를 남겨주시면 담당자가 {t2}노출 가능 채널과<br className="hidden sm:block" /> 예상 효과를 안내해 드립니다.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex w-full flex-col items-center gap-7 text-center lg:w-[515px] lg:items-start lg:gap-[30px] lg:text-left">{t3}<ul className="flex flex-col gap-3 pt-2">{CHECK_POINTS.map(_temp)}</ul></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-7 flex flex-col gap-[5px] lg:mb-9"><h3 className="break-keep font-[family-name:var(--font-nanum-square-neo)] text-[22px] font-extrabold leading-[33px] tracking-[-0.4px] text-[#16143e]">상담 신청</h3><p className="break-keep text-[14px] leading-[22.28px] text-[#121212]">1분이면 신청이 완료됩니다.</p></div>;
    t6 = <ApplyForm />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section id="apply" className="w-full bg-[#e6e5ff]"><div className="mx-auto w-full max-w-[1140px] px-5 py-16 lg:px-0 lg:py-[65px]"><div className="flex flex-col items-stretch gap-10 lg:flex-row lg:items-center lg:justify-between lg:gap-12">{t4}<div className="w-full rounded-xl bg-white p-6 shadow-[0_4px_24px_rgba(16,20,62,0.06)] sm:p-8 lg:w-[515px] lg:rounded-[22px] lg:px-[30px] lg:py-[34px] lg:shadow-[0_24px_60px_-28px_rgba(16,48,44,0.45)]">{t5}{t6}<p className="mt-7 break-keep text-center text-[12px] leading-[1.5] text-[#727272] lg:mt-[34px]">신청 시 개인정보 수집·이용에 동의한 것으로 처리됩니다.<br />※ 1개월 무료 체험은 베이직 플랜에 한해 제공됩니다.</p></div></div></div></section>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
export default ApplyCta;
function _temp(point) {
  return <li key={point} className="flex items-center gap-2.5"><CheckMark className="h-[13px] w-[13px] shrink-0 text-[#3700ff]" /><span className="break-keep text-[15px] leading-[24.75px] text-black">{point}</span></li>;
}